import ordersService from './ordersService';

export * from './utils';
export default ordersService;



// WEBPACK FOOTER //
// ./src/services/orders/index.ts